import {Exclude, Expose, Type} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {UserApiModel} from "./user.api-model";
import {ChatAttachmentApiModel} from "./chat-attachment.api-model";
import {ShareRefApiModel} from './share-ref.api-model';
import {ShareCardApiModel} from './share-card.api-model';

@Exclude()
export class ChatMessageApiModel extends AbstractApiModel {
  @Expose() public id: string;
  @Expose() public conversation: string;
  @Expose()
  @Type(() => UserApiModel)
  public sender: UserApiModel | string;
  @Expose()
  @Type(() => UserApiModel)
  public recipient: UserApiModel | string;
  @Expose() public content?: string;
  @Expose()
  @Type(() => ChatAttachmentApiModel)
  public attachments?: ChatAttachmentApiModel[]|string[];
  @Expose() public messageType?: string;
  @Expose() public shareType?: string | null;
  @Expose() public shareId?: string | null;
  @Expose()
  @Type(() => ShareRefApiModel)
  public shareRef?: ShareRefApiModel | null;
  @Expose()
  @Type(() => ShareCardApiModel)
  public shareCard?: ShareCardApiModel | null;
  @Expose() public createdAt?: Date;
  @Expose() public updatedAt?: Date;
  public clientTempId?: string;
  public localStatus?: 'pending' | 'failed';
}
